import { cloneElement, memo } from "react";
import { Button } from "@heroui/react";
import { motion, AnimatePresence } from "framer-motion";

import { ICON_SIZE } from "@/config/constants";
import { useBoundStore } from "@/app/store";

export interface FabDesktopProps {
  icon: React.ReactElement;
  style?: React.CSSProperties;
  onPress?: () => void;
}

function FabDesktopComponent() {
  const fab = useBoundStore((state) => state.pageLayout.fab);
  const showBottomNavigation = useBoundStore((state) => state.pageLayout.showBottomNavigation);

  if (!fab) {
    return null;
  }

  const iconElement = cloneElement(fab.icon, {
    size: ICON_SIZE.lg,
    weight: "bold",
  });

  return (
    <AnimatePresence>
      {fab && !showBottomNavigation ? (
        <motion.div
          className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ type: "spring", stiffness: 100, damping: 15 }}
        >
          <Button className="font-semibold" color="primary" isIconOnly radius="full" size="lg" onPress={fab.onPress}>
            {iconElement}
          </Button>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}

export const FabDesktop = memo(FabDesktopComponent);
